import { render, staticRenderFns } from "./TaskManagerPersonalIndex.vue?vue&type=template&id=53e18d70&scoped=true"
import script from "./TaskManagerPersonalIndex.vue?vue&type=script&lang=js"
export * from "./TaskManagerPersonalIndex.vue?vue&type=script&lang=js"
import style0 from "./TaskManagerPersonalIndex.vue?vue&type=style&index=0&id=53e18d70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e18d70",
  null
  
)

export default component.exports